(function (window) {
  window.componentEvents.on('consumer-rx-form-instantiate', init);

  /**
   * Instantiate a single form.
   */
  function init(form) {
    // Find all elements with a `name` attribute.
    const formControls = form.querySelectorAll('[name]');
    formControls.forEach((control, index) => {
      updateFormControlId(control, index, form);
    });
  }

  /**
   * Update a given form control’s ID, as well as any labels pointing to it.
   *
   * @param control - The DOM Node for the form control being processed.
   * @param index - A zero-based index indicating the control’s position
   *   in the array of form controls being processed.
   * @param form - The DOM Node for the form within which this form control
   *   exists.
   */
  function updateFormControlId(control, index, form) {
    // First, define the ID as the control’s current ID, using a fallback if
    // none is found.
    let newId = (control.id || `form-control-${index + 1}`);
    // Amend the ID with the form’s own ID as a suffix.
    newId += `-${form.id}`;
    // Find all labels with a `for` attribute pointing to the control’s
    // original ID if it has one, falling back to an empty array otherwise.
    const labels = control.id ?
      form.querySelectorAll(`label[for=${control.id}]`) : [];
    // Set the control’s ID to be the newly created ID.
    control.id = newId;
    // Point any labels that may have been found to the new ID.
    labels.forEach((label) => label.setAttribute('for', newId));
  }
})(window);
